import { service } from "@theme";
import SolidButton from "@ui/goono/components/buttons/SolidButton";
import GoonoTypography from "@ui/goono/components/typo/GoonoTypography";
import React from "react";
import { useDispatch } from "react-redux";
import GoonoErrorImage from "src/assets/images/goono-error.png";
import { resetToken } from "src/redux/store/reducers/token";
import ScreenURL from "src/routes/route_list";
import { ErrorBoundary } from "react-error-boundary";

type Props = {
  children: React.ReactChild;
};

export default function AdminErrorBoundary(props: Props) {
  const dispatch = useDispatch();

  const resetServiceCache = () => {
    resetToken(dispatch);
    setTimeout(() => window.location.replace(ScreenURL.LOGIN), 100);
  };

  const renderFallbackView = () => {
    return (
      <div
        style={{
          width: `100%`,
          height: `100vh`,
          display: `flex`,
          flexDirection: `column`,
          justifyContent: `center`,
          alignItems: `center`,
          background: service.gray_100,
        }}
      >
        <img src={GoonoErrorImage} style={{ width: 200 }} />
        <GoonoTypography type="h4" style={{ margin: `20px 0` }}>
          문제가 발생하였습니다.
        </GoonoTypography>
        <SolidButton
          buttonSize="lg"
          buttonType="primary_line"
          onClick={resetServiceCache}
        >
          로그인 화면으로 돌아가기
        </SolidButton>
      </div>
    );
  };

  return (
    <ErrorBoundary
      fallback={renderFallbackView()}
      onError={(err) => console.log(`에러 사유 : `, err)}
    >
      {props.children}
    </ErrorBoundary>
  );
}
